export default __webpack_public_path__ + "static/media/IMG_0419-2.3f0b5e67.jpg";